export type AnyFunction = (this: any, ...args: any[]) => any;
